import { ApiType } from "@gymflow/common";
import { useMutation } from "@tanstack/react-query";

export function useMutationKisiInitialize({ api }: { api: ApiType }) {
  return useMutation({
    mutationFn: ({
      clubId,
      kisiPlaceId,
      membershipToGroupMap,
      facilityToGroupMap,
    }: {
      clubId: Parameters<ApiType["kisiApi"]["initialize"]>[0];
      kisiPlaceId: Parameters<ApiType["kisiApi"]["initialize"]>[1];
      membershipToGroupMap: Parameters<ApiType["kisiApi"]["initialize"]>[2];
      facilityToGroupMap: Parameters<ApiType["kisiApi"]["initialize"]>[3];
    }) => {
      return api.kisiApi.initialize(
        clubId,
        kisiPlaceId,
        membershipToGroupMap,
        facilityToGroupMap,
      );
    },
  });
}
